module.exports = __webpack_public_path__ + "static/media/compatible-cast.d526b35e.png";